/**
 * api設定位置
 */

const serverProtocol = location.protocol == "http:" ? "http://" : "https://";
// 分中儲 及 其他用台南
const systemInit =
    serverProtocol +
    (() => {
        switch (`${document.domain}:${location.port}`) {
            case "www.cub.org.tw:":
                return "www.cub.org.tw/";
            case "culroc.dev.com.tw:804":
                return "culroc.dev.com.tw:804/";
            case "culroc.dev.com.tw:801":
                return "culroc.dev.com.tw:801/";
            case "192.168.0.201:":
                return "192.168.0.201/";
            //case "localhost:8080":
            //    return "61.221.52.20/";
            default:
                const port = (location.port == 8080) ? 63164 : location.port;
                return `${document.domain}:${port}/`;
        }
    })();
// const systemInit = serverProtocol + (document.domain == 'www.cub.org.tw' ? 'www.cub.org.tw/' : 'culroc.dev.com.tw:801/');
// const systemInit = serverProtocol + (document.domain == 'www.cub.org.tw' ? 'www.cub.org.tw/api/' : 'localhost:63164/');

const system = systemInit + "api/";

const API = {
    system: systemInit,
    auth: system + "auth", // 使用者登入
    agent: system + "agent", // 取得代理人資料
    personalData: system + "personalData", //修改個人資料
    assnTask: system + "assnTask", // 協會個人工作管理
    AssnIndex: system + "AssnIndex", //協會通知
    coopTask: system + "coopTask", // 儲互社個人工作管理
    CoopIndex: system + "CoopIndex", //儲互社通知
    sysNotify: system + "sysNotify", // 通知
    //// 協會

    /// 系統管理
    AssnUser: system + "AssnUser", // 系統使用者
    // 樹狀
    genJob: system + "genJob", // 職業管理
    genStakeholderType: system + "genStakeholderType", // 利害關係人名稱管理
    sysPermMenu: system + "sysPermMenu", // 選單管理
    sysPermItem: system + "sysPermItem", // 權限管理
    genRace: system + "genRace", // 族別管理
    genCity: system + "genCity", // 縣市區域管理
    genLoanCollection: system + "genLoanCollection", // 法催工作設定
    // 權限管理
    sysPermRole: system + "sysPermRole", // 角色管理
    sysPermAssnWork: system + "sysPermAssnWork", // 協會業務設定
    sysPermCoopWork: system + "sysPermCoopWork", // 儲互社業務設定
    reviewDefine: system + "reviewDefine", // 儲互社審查作業設定
    // 通用設定
    genLoanAssetRate: system + "GenLoanAssetRate", // 全域參數設定/放款資產明細評估提撥比例設定
    genAssnData: system + "genAssnData", // 全域參數設定/協會基本資料
    genAssnParams: system + "genAssnParams", // 全域參數設定/協會基本設定
    genAssnLoan: system + "genAssnLoan", // 全域參數設定/放款通用限制
    genAssnLoanCp: system + "genAssnLoanCp", // 全域參數設定/信用放款自然人限制
    genAssnLoanCa: system + "genAssnLoanCa", // 全域參數設定/信用放款法人限制
    genAssnLoanMp: system + "genAssnLoanMp", // 全域參數設定/擔保放款自然人限制
    genAssnLoanMa: system + "genAssnLoanMa", // 全域參數設定/擔保放款法人限制
    genAssnLoanAgr: system + "genAssnLoanAgr", // 全域參數設定/協議放款限制
    genAssnYearEnd: system + "genAssnYearEnd", // 全域參數設定年結設定
    genYearStockRate: system + "genYearStockRate", // 歷年全國平均股息率
    genLoanBreakDateException: system + "genLoanBreakDateException", // 還款寬限例外設定
    genLoanProject: system + "genLoanProject", // 專案放款設定
    genLoanProjectApply: system + "genLoanProjectApply", // 專案放款設定/申請件管理
    assnAccountTitle: system + "assnAccountTitle", // 會計科目管理
    genTitle: system + "genTitle", // 職稱管理
    genRegionalBranch: system + "genRegionalBranch", // 區會管理
    genLoanTypes: system + "genLoanTypes", // 借款用途管理
    scheduleTask: system + "scheduleTask", // 系統排程設定
    genReport: system + "genReport", // 一般報表設定
    exitReason: system + "exitReason", // 退社原因設定

    // 儲互社管理
    assnCoop: system + "assnCoop", // 儲互社管理
    assnCoopBusinessHour: system + "assnCoopBusinessHour", // 儲互社營業時間
    assnCoopUser: system + "assnCoopUser", // 儲互社人員管理
    coopDevices: system + "coopDevices", // 儲互社裝置管理
    assnReviewCoopDefine: system + "assnReviewCoopDefine", // 儲互社審查作業管理
    coopLoan: system + "coopLoan", // 放款開放設定
    InsCoop: system + "InsCoop", // 放款開放設定
    // 系統訊息管理
    sysMsg: system + "sysMsg", // 訊息設定
    sysMsgLog: system + "sysMsgLog", // 錯誤訊息管理
    // 公告管理
    announcement: system + "announcement", // 公告管理
    // 簡訊管理
    sms: system + "sms", // 簡訊使用紀錄管理
    assnSmsOrder: system + "assnSmsOrder", // 簡訊購買紀錄管理
    coopSmsOrder: system + "coopSmsOrder", // 儲互社簡訊購買紀錄
    assnCoopSms: system + "assnCoopSms", // 儲互社簡訊使用紀錄

    smsConfig: system + "smsConfig", // 簡訊設定

    /// 安基業務管理
    InsReceive: system + "InsReceive", // 收件作業
    // LPLS
    InsLplsParams: system + "InsLplsParams", // 參數設定
    InsLplsYear: system + "InsLplsYear", // 年度與保障期間設定
    InsLpCoopRate: system + "InsLpCoopRate", // LP 儲互社費率及保額設定
    InsLpCoopRateDoc: system + "InsLpCoopRateDoc", // LP 儲互社費率及保額設定 - 相關文件
    InsLsCoopRate: system + "InsLsCoopRate", // LS 儲互社費率及保額設定
    InsLsCoopRateDoc: system + "InsLsCoopRateDoc", // LS 儲互社費率及保額設定 - 相關文件
    InsLplsClaimApply: system + "InsLplsClaimApply", // LPLS  / LPLS 理賠申請
    LplsAnnouncement: system + "LplsAnnouncement", // LPLS  / LPLS 申報表公告設定

    // BOND
    InsBondParams: system + "InsBondParams", // 參數設定
    InsBondYear: system + "InsBondYear", // 年度與保障期間設定
    InsBondCoopDiscountRate: system + "InsBondCoopDiscountRate", // 折扣率設定
    InsBondCoopApply: system + "InsBondCoopApply", // 年度續約申請管理
    InsBondClaimapply: system + "InsBondClaimapply", // 理賠申請管理
    InsBondAssnIncome: system + "InsBondAssnIncome", //BOND相關報表
    InsBondReportClaim: system + "InsBondReportClaim", //相關報表-彙總表-互助支出
    InsBondCoopReport: system + "InsBondCoopReport", //相關報表-彙總表
    InsBondReserveRcd: system + "InsBondReserveRcd", //相關報表-列印紀錄

    // 代辦互助基金
    InsPlanMain: system + "InsPlanMain", // 方案設定
    InsPlanYear: system + "InsPlanYear", // 年度與保障期間設定
    InsPlanSub: system + "InsPlanSub", // 子方案設定
    InsPlanRollInout: system + "InsPlanRollInout", // 加退保名冊設定
    InsPlanRollChange: system + "InsPlanRollChange", // 資料變更名冊設定
    InsPlanDoc: system + "InsPlanDoc", // 文件設定
    InsPlanAs: system + "InsPlanAs", // 會計科目設定
    InsPlanClaim: system + "InsPlanClaim", // 理賠項目與文件設定
    InsPlanClaimDoc: system + "InsPlanClaimDoc", // 理賠項目設定相關文件
    InsPlanClaimItem: system + "InsPlanClaimItem", // 理賠項目與文件對應
    InsPlanCoop: system + "InsPlanCoop", // 儲互社開辦設定
    InsPlanMemberApply: system + "InsPlanMemberApply", // 儲互社加保申請名冊管理(含通過/不通過/補件)
    InsPlanMemberApplyPackage: system + "InsPlanMemberApplyPackage", // 儲互社加退保申請送件管理
    InsPlanMemberApplyBnf: system + "InsPlanMemberApplyBnf", // 受益人
    InsPlanMember: system + "InsPlanMember", // 儲互社參加名冊管理
    InsPlanMemberBnf: system + "InsPlanMemberBnf", // 受益人資料
    InsPlanMemberPayment: system + "InsPlanMemberPayment", // 社員互助費明細
    InsPlanMemberClaim: system + "InsPlanMemberClaim", // 理賠申請
    UnifiedClaim: system + "UnifiedClaim", // 統一理賠資料（三表合併）
    InsPlanAssnIncome: system + "InsPlanAssnIncome", //實收保費財務明細
    InsPlanAssnPay: system + "InsPlanAssnPay", //給付保險公司,
    InsPlanRace: system + "InsPlanRace", //業務競賽
    InsPlanReport: system + "InsPlanReport", //彙總表
    InsPlanReserveRcd: system + "InsPlanReserveRcd", //月報表
    InsPlanReserveDetailRcd: system + "InsPlanReserveDetailRcd", //月報表明細
    InsPlanMemberApplyPackageDetail: system + "InsPlanMemberApplyPackageDetail", // 社員互助費明細
    insPlanMemberClaim: system + "insPlanMemberClaim", //理賠申請社員
    insPlanMemberApply: system + "insPlanMemberApply", //列印名冊彙總表
    InsPlanPaymentMain: system + "InsPlanPaymentMain", //經辦費設定
    InsPlanPaymentDetail: system + "InsPlanPaymentDetail", //經辦費設定 細項
    // 幹部互助基金
    InsCadreMain: system + "InsCadreMain", // 方案設定
    InsCadreYear: system + "InsCadreYear", // 年度與保障期間設定
    InsCadreSub: system + "InsCadreSub", // 子方案設定
    InsCadreRollInout: system + "InsCadreRollInout", // 加退保名冊設定
    InsCadreRollChange: system + "InsCadreRollChange", // 資料變更名冊設定
    InsCadreDoc: system + "InsCadreDoc", // 文件設定
    InsCadreAs: system + "InsCadreAs", // 會計科目設定
    InsCadreMemberApplyPackage: system + "InsCadreMemberApplyPackage", // 儲互社加退保申請送件管理,
    InsCadreMemberApplyPackageDetail: system + "InsCadreMemberApplyPackageDetail", //儲互社加退保申請送件管理-編輯
    InsCadreMemberApply: system + "InsCadreMemberApply", // 儲互社加保申請名冊管理(含通過/不通過/補件)
    InsCadreMember: system + "InsCadreMember", // 參加名冊,
    InsCadreClaim: system + "InsCadreClaim", //理賠申請
    InsCadreClaimDoc: system + "InsCadreClaimDoc", //理賠申請
    InsCadreClaimItem: system + "InsCadreClaimItem", //理賠項目新增,
    InsCadreMemberBnf: system + "InsCadreMemberBnf", //參加名冊-受益人,
    InsCadreMemberClaim: system + "InsCadreMemberClaim", //理賠申請管理
    insCadreMemberClaim: system + "insCadreMemberClaim",
    InsCadrePaymentMain: system + "InsCadrePaymentMain", //經辦費設定
    InsCadrePaymentDetail: system + "InsCadrePaymentDetail", //經辦費設定修改細項
    InsCadreMemberApplyBnf: system + "InsCadreMemberApplyBnf", // 受益人資料

    // 員工保
    InsEmployeeMain: system + "InsEmployeeMain", // 方案設定
    InsEmployeeYear: system + "InsEmployeeYear", // 年度與保障期間設定
    InsEmployeeSub: system + "InsEmployeeSub", // 子方案設定
    InsEmployeeRollInout: system + "InsEmployeeRollInout", // 加退保名冊設定
    InsEmployeeRollChange: system + "InsEmployeeRollChange", // 資料變更名冊設定
    InsEmployeeDoc: system + "InsEmployeeDoc", // 文件設定
    InsEmployeeAs: system + "InsEmployeeAs", // 會計科目設定
    InsEmployeeMemberApplyPackage: system + "InsEmployeeMemberApplyPackage", // 儲互社加退保申請送件管理,
    InsEmployeeMemberApplyPackageDetail: system + "InsEmployeeMemberApplyPackageDetail", //儲互社加退保申請送件管理-編輯
    InsEmployeeMemberApply: system + "InsEmployeeMemberApply", // 儲互社加保申請名冊管理(含通過/不通過/補件)
    InsEmployeeMember: system + "InsEmployeeMember", // 參加名冊,
    InsEmployeeClaim: system + "InsEmployeeClaim", //理賠申請
    InsEmployeeClaimDoc: system + "InsEmployeeClaimDoc", //理賠申請
    InsEmployeeClaimItem: system + "InsEmployeeClaimItem", //理賠項目新增,
    InsEmployeeMemberBnf: system + "InsEmployeeMemberBnf", //參加名冊-受益人,
    InsEmployeeMemberClaim: system + "InsEmployeeMemberClaim", //理賠申請管理
    insEmployeeMemberClaim: system + "insEmployeeMemberClaim",
    InsEmployeePaymentMain: system + "InsEmployeePaymentMain", //經辦費設定
    InsEmployeePaymentDetail: system + "InsEmployeePaymentDetail", //經辦費設定修改細項
    InsEmployeeMemberApplyBnf: system + "InsEmployeeMemberApplyBnf", // 受益人資料

    // 六年平儲
    InsSavingMain: system + "InsSavingMain", // 專案設定
    InsSavingCoop: system + "InsSavingCoop", // 開辦設定
    InsSavingParams: system + "InsSavingParams", // 參數設定

    /// 督導資料查詢
    AssnLoanIouModify: system + "AssnLoanIouModify",
    SupervisionReview: system + "SupervisionReview", // 督導審查
    SupervisionManagerReview: system + "SupervisionManagerReview", // 督導組組長審查
    SupervisionReviewWorkingPaper: system + "SupervisionReviewWorkingPaper", //查核工作底稿
    SupervisionReviewWorkingPaperIou: system + "SupervisionReviewWorkingPaperIou", //查核工作底稿借據
    SupervisionReviewWorkingPaperDoc: system + "SupervisionReviewWorkingPaperDoc", //查核工作底稿檔案上傳
    SupervisionReviewWorkingPaperAssistUser: system + "SupervisionReviewWorkingPaperAssistUser", //查核工作底稿協做督導

    //// 儲互社
    /// 人事差勤
    coopUser: system + "coopUser", // 使用者帳號管理
    coopUserLeave: system + "coopUserLeave", // 個人請假管理
    personnel: system + "personnel", // 人事差勤首頁

    /// 系統管理
    coopParams: system + "coopParams", // 儲互社各項作業參數設定
    reviewCoopDefine: system + "reviewCoopDefine", // 審查作業管理
    coopSmsApply: system + "coopSmsApply", // 簡訊購買紀錄管理
    coopAccountTitle: system + "coopAccountTitle", // 會計科目管理
    coopLeader: system + "coopLeader", // 歷屆選任理監事名單
    coopSupv: system + "coopSupv", // 歷屆聘任幹部名單
    coopSms: system + "coopSms", // 簡訊使用
    meetingRcd: system + "meetingRcd", // 會議記錄管理
    coopGlossary: system + "coopGlossary", // 中文詞彙建檔管理
    coopBank: system + "coopBank", // 銀行帳戶管理
    bankCode: system + "bankCode", //銀行帳戶的銀行清單
    coopHire: system + "coopHire", // 聘僱人員名單

    /// 臨櫃作業
    //// 社員
    memberGroup: system + "memberGroup", // 社員群組管理
    member: system + "member", // 社員資料管理社員 , 準社員資料管理
    memberMonthlyOverStock: system + "memberMonthlyOverStock", // 社員資料管理社員 , 準社員資料管理
    memberStakeholder: system + "memberStakeholder", // 利害關係人
    memberNote: system + "memberNote", // 社員記事
    memberApply: system + "memberApply", // 準社員入社申請資料管理
    memberApplyReviewBatch: system + "memberApplyReviewBatch", // 準社員升社員
    memberApplyReview: system + "memberApplyReview", //準社員升社員總欄
    memberExitApply: system + "memberExitApply", //退社
    memberTransferCoopOutApply: system + "memberTransferCoopOutApply", //社員轉出
    memberTransferCoopInApply: system + "memberTransferCoopInApply", //社員轉入
    memberExitApplyAttached: system + "memberExitApplyAttached", //退社附件
    memberRetirementStockApply: system + "memberRetirementStockApply", //退股金管理
    //// 現金收款作業
    counterWork: system + "counterWork", // 現金收款作業
    memberTransferMemo: system + "memberTransferMemo", // 社員轉帳備忘錄
    coopBankTransactionCheck: system + "coopBankTransactionCheck", // 交易明細核對
    //// 備查簿
    coopNtDepositOrder: system + "coopNtDepositOrder", // 台幣定存單管理
    coopPettyCash: system + "coopPettyCash", // 零用金備查簿

    ////資料查印
    coopReport: system + "coopReport",
    CoopReport: system + "CoopReport",

    /// 安基作業
    // LPLS
    coopInsLpls: system + "coopInsLpls", // 開辦查詢
    coopInsLplsClaimApply: system + "coopInsLplsClaimApply", // 理賠申請
    coopLPLSReport: +"", // LPLS申報表明細報表
    coopInsLplsReport: system + "CoopReport", // 法人備轉金
    getInsLpCoopRateDoc: system + `coopInsLpls`,
    COMMRPTLPLSDETAIL: system + `COMMRPTLPLSDETAIL`, //LPLS 明細對帳單

    // BOND
    coopInsBond: system + "coopInsBond", // 開辦查詢
    coopInsBondClaimApply: system + "coopInsBondClaimApply", // 理賠申請

    // 代辦互助基金
    coopInsPlan: system + "coopInsPlan", // 基本資料
    coopInsPlanDoc: system + "coopInsPlanDoc", // 相關文件
    coopInsPlanMember: system + "coopInsPlanMember", // 參加名冊
    coopInsPlanMemberBnf: system + "coopInsPlanMemberBnf", // 受益人資料
    coopInsPlanMemberApply: system + "coopInsPlanMemberApply", // 加保申請 退保申請 資料變更申請
    coopInsPlanMemberApplyBnf: system + "coopInsPlanMemberApplyBnf", // 受益人資料
    coopInsPlanMemberApplyPackage: system + "coopInsPlanMemberApplyPackage", // 加退保合併送件 資料變更申請合併送件
    coopInsPlanMemberClaim: system + "coopInsPlanMemberClaim", // 理賠申請
    coopInsPlanMemberPayment: system + "coopInsPlanMemberPayment", // 社員互助費明細
    coopInsPlanMemberApplyPackageDetail: system + "coopInsPlanMemberApplyPackageDetail", // 社員互助費明細
    coopInsPlanPaymentMain: system + "coopInsPlanPaymentMain", //互助費與經辦費明細
    coopInsPlanMemberApplyRenew: system + "coopInsPlanMemberApplyRenew", // 續約

    ///社員資料管理
    ///六年平儲
    memberInsSaving: system + `memberInsSaving`,

    // 幹部互助基金
    coopInsCadreMain: system + "coopInsCadreMain", // 基本資料
    coopInsCadreSub: system + "coopInsCadreSub", // 子方案
    coopInsCadreYear: system + "coopInsCadreYear", // 保險年度
    coopInsCadreDoc: system + "coopInsCadreDoc", // 相關文件
    coopInsCadreMember: system + "coopInsCadreMember", // 參加名冊
    coopInsCadreMemberBnf: system + "coopInsCadreMemberBnf", // 受益人資料
    coopInsCadreMemberApply: system + "coopInsCadreMemberApply", // 加保申請 退保申請 資料變更申請 加保匯入幹部
    coopInsCadreMemberApplyBnf: system + "coopInsCadreMemberApplyBnf", // 受益人資料
    coopInsCadreMemberApplyPackage: system + "coopInsCadreMemberApplyPackage", // 加退保合併送件 資料變更申請合併送件
    coopInsCadreMemberApplyPackageDetail: system + "coopInsCadreMemberApplyPackageDetail", //加退保合併 列印名冊
    coopInsCadreMemberClaim: system + "coopInsCadreMemberClaim", // 理賠申請

    // 儲互社員工保
    coopInsEmployeeMain: system + "coopInsEmployeeMain", // 基本資料
    coopInsEmployeeSub: system + "coopInsEmployeeSub", // 子方案
    coopInsEmployeeYear: system + "coopInsEmployeeYear", // 保險年度
    coopInsEmployeeDoc: system + "coopInsEmployeeDoc", // 相關文件
    coopInsEmployeeMember: system + "coopInsEmployeeMember", // 參加名冊
    coopInsEmployeeMemberBnf: system + "coopInsEmployeeMemberBnf", // 受益人資料
    coopInsEmployeeMemberApply: system + "coopInsEmployeeMemberApply", // 加保申請 退保申請 資料變更申請 加保匯入幹部
    coopInsEmployeeMemberApplyBnf: system + "coopInsEmployeeMemberApplyBnf", // 受益人資料
    coopInsEmployeeMemberApplyPackage: system + "coopInsEmployeeMemberApplyPackage", // 加退保合併送件 資料變更申請合併送件
    coopInsEmployeeMemberApplyPackageDetail: system + "coopInsEmployeeMemberApplyPackageDetail", //加退保合併 列印名冊
    coopInsEmployeeMemberClaim: system + "coopInsEmployeeMemberClaim", // 理賠申請
    coopInsEmployeeMemberPayment: system + "coopInsEmployeeMemberPayment", //帳務處理

    // 六年平儲
    coopInsSavingApply: system + "coopInsSavingApply", // 基本資料

    /// 放款作業
    coopLoanProject: system + "coopLoanProject", // 放款專案設定
    coopLoanProjectDoc: system + "coopLoanProjectDoc", // 放款專案文件設定
    coopLoanProjectRate: system + "coopLoanProjectRate", // 利率調整
    coopLoanApply: system + "coopLoanApply", // 放款申請
    coopLoanApplyGuarantor: system + "coopLoanApplyGuarantor", // 放款申請/保證人
    coopLoanApplyDoc: system + "coopLoanApplyDoc", // 放款申請/申請文件
    coopLoanApplyFinancial: system + "coopLoanApplyFinancial", // 放款申請/財務狀況
    coopLoanApplyCollateral: system + "coopLoanApplyCollateral", // 放款申請/擔保品鑑價與審查
    coopLoanIou: system + "coopLoanIou", // 放款申請/借據
    coopLoanApplyCommitteeFlow: system + "coopLoanApplyCommitteeFlow", // 放款申請/放款委員會審查
    coopLoanApplyCouncilFlow: system + "coopLoanApplyCouncilFlow", // 放款申請/理事會審查
    coopLoanTrialTable: system + "coopLoanTrialTable", // 還款試算表
    coopLoanIouRepaymentRecord: system + "coopLoanIouRepaymentRecord", // 還款紀錄
    coopLoanIouWithdrawalRecord: system + "coopLoanIouWithdrawalRecord", // 借款紀錄

    coopLoanIouColtPhone: system + "coopLoanIouColtPhone", // 貸後管理/借據/電話催收工作管理
    coopLoanIouColtPhoneRcd: system + "coopLoanIouColtPhoneRcd", // 貸後管理/借據/電話催收工作管理細節
    coopLoanIouColtPaper: system + "coopLoanIouColtPaper", // 貸後管理/借據/書面催收工作管理
    coopLoanIouColtPaperRcd: system + "coopLoanIouColtPaperRcd", // 貸後管理/借據/書面催收工作管理細節
    coopLoanIouColtLaw: system + "coopLoanIouColtLaw", // 貸後管理/借據/法律催收工作管理
    coopLoanIouColtLawRcd: system + "coopLoanIouColtLawRcd", // 貸後管理/借據/法律催收工作管理細節
    coopLoanIouDoc: system + "coopLoanIouDoc", // 貸後管理/借據/相關文件管理
    coopLoanIouCollateral: system + "coopLoanIouCollateral", // 貸後管理/借據/擔保品管理
    coopLoanIouAgr: system + "coopLoanIouAgr", //貸後管理/借據/延期協議設定
    coopLoanIouOverAgr: system + "coopLoanIouOverAgr", //貸後管理/借據/延期協議設定
    coopLoanIouDead: system + "coopLoanIouDead", //貸後管理/借據/呆帳轉銷
    coopLoanIouDeadDoc: system + "coopLoanIouDeadDoc", //貸後管理/借據/呆帳轉銷文件上傳
    coopLoanIouDeadPayLog: system + "coopLoanIouDeadPayLog", //貸後管理/借據/呆帳轉銷後收回
    coopLoanReport: system + "coopLoanReport", //放款應收利息試算表
    coopLoanIouModify: system + "coopLoanIouModify", //貸後管理/借據/借款條件異動處理
    coopLoanIouGuarantor: system + "coopLoanIouGuarantor", // 貸後管理/保證人 

    /// 審查作業
    coopReview: system + "coopReview", // 審查作業
    /// 會計作業
    coopWaitVoucher: system + "coopWaitVoucher", // 傳票確認
    coopVoucher: system + "coopVoucher", // 請款單 傳票管理
    memberPayrollDeduction: system + "memberPayrollDeduction", // 社員薪資轉帳作業
    coopEmployeeSalaryItem: system + "coopEmployeeSalaryItem", // 職員薪資項目設定
    coopEmployeeSalary: system + "coopEmployeeSalary", // 職員薪資計算作業
    coopEmployeeSalaryList: system + "coopEmployeeSalaryList", // 職員薪資名單
    coopEmtrustedTransfer: system + "coopEmtrustedTransfer", // 委託轉帳作業
    CoopEmtrustedTransfer: system + "CoopEmtrustedTransfer",
    CoopSpecTransfer: system + "CoopSpecTransfer", //特定轉帳
    CoopSpecTransferList: system + "CoopSpecTransferList", //特定轉帳明細
    CoopYearTaxMember: system + "CoopYearTaxMember", // 股息扣繳媒體申報資料轉出
    CoopYearTaxSet: system + "CoopYearTaxSet", // 股息扣繳媒體申報單位資料

    CoopYearBudget: system + "CoopYearBudget", //年度預算
    CoopYearBudgetDetail: system + "CoopYearBudgetDetail", //年度預算新增科目
    /// 出納作業
    coopBankTransaction: system + "coopBankTransaction", // 銀行交易明細管理
    coopPropertyInventory: system + "coopPropertyInventory", // 財產清冊管理

    /// 日結作業
    dailySettlementMgr: system + "dailySettlementMgr", // 日結作業(含主管、臨櫃、出納、會計)
    dailySettlementVoucherCreator: system + "dailySettlementVoucherCreator", // 取得當日人員開立的全部傳票資料，包含計算加總
    dailySettlementCashier: system + "dailySettlementCashier", // 取得當日出納關帳資訊
    dailySettlementAccountant: system + "dailySettlementAccountant", // 取得當日會計關帳資訊

    ///月結作業
    coopMonthStl: system + "coopMonthStl",
    coopLplsReport: system + "coopLplsReport",
    coopMonthReport: system + "coopMonthReport",

    ///年結作業
    CoopAccReport: system + "CoopAccReport",
    CoopYearStl: system + "CoopYearStl", //年結年份設定
    CoopYearStlAcsmp: system + "CoopYearStlAcsmp", //發放項目設定
    CoopYearStlAcsmpDis: system + "CoopYearStlAcsmpDis", //代扣項目設定
    CoopYearStlCal: system + "CoopYearStlCal", //年結試算
    CoopYearStlRpt: system + "CoopYearStlRpt", //年結報表
    CoopYearStlCugusi: system + "CoopYearStlCugusi", //股息發放代扣
    memberBankStatementRemark: system + "memberBankStatementRemark", // 對帳單備註欄註記管理
    MemberSharesRecord: system + "MemberSharesRecord", // 圓股數紀錄
    /// 請款作業
    invoice: system + "invoice", // 臨櫃人員

    //雜誌訂閱資料
    COMMRPTMAGZIN: system + "COMMRPTMAGZIN", //雜誌訂閱資料

    //自動傳票清單明細
    coopEntryReport: system + "CoopEntryReport",
};

export {
    API
};